module.exports = __webpack_public_path__ + "img/4.c71ca799.jpg";